import { MicromedidoresService } from './../../../../services/micromedidores.service';
import { MapaService } from './../../../../services/mapa.service';
import { DatePipe } from '@angular/common';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material';
import { Micromedidor, MicromedidorUltimaTransmision } from './../../../../../../_entities/micromedidores/micromedidor';
import { DxDataGridComponent } from 'devextreme-angular';
import { Component, OnInit, ViewChild } from '@angular/core';
import { InformacionMicromedidorComponent } from '../../../popups/micromedidores/informacion-micromedidor/informacion-micromedidor.component';
import { Service, Customer } from './app.service'; /*este es una prueba del demo*/
import { User } from '../../../../../../_entities/User'; /*este es una prueba del demo*/
import { AuthService } from '../../../../../auth/auth.service';

@Component({
	selector: 'kt-micromedidor-modal',
	templateUrl: './micromedidor-modal.component.html',
	styleUrls: ['./micromedidor-modal.component.scss'],
	providers: [Service] /*este es una prueba del demo*/
})
export class MicromedidorModalComponent implements OnInit {
	_user: User;
	public usuarioDemo: boolean = true;
	customers: Customer[]; /*este es una prueba del demo*/
	@ViewChild(DxDataGridComponent, { static: false }) dataGrid: DxDataGridComponent
	public applyFilterTypes: any;
	public currentFilter: any;
	public showFilterRow: boolean;
	public showHeaderFilter: boolean;
	public usuario; dataSource: MicromedidorUltimaTransmision[];
	public datosReporte = [];
	 isDisabled: boolean = true;

	constructor(private micromedidorService: MicromedidoresService, service: Service /*este es una prueba del demo*/, private auth: AuthService /*este es una prueba del demo*/,
		private dialogRef: MatDialogRef<MicromedidorModalComponent>,
		private dialog: MatDialog, private mapaService: MapaService, private datePipe: DatePipe) { 
			this.customers = service.getCustomers(); /*este es una prueba del demo*/
		}

	ngOnInit() {
		this.obtenerListaMicromedidores();
		// demo
		this._user = this.auth.getUser();
		if(this._user.id === "6cac2e07-cb6d-4725-93d7-ed7ad39f5ade"){
			this.usuarioDemo = false;
		}
		// demo
	}

	obtenerListaMicromedidores() {
		let temNumSeries = [];
		let newResponse = []
		this.micromedidorService.obtenerMicromedidoresUltimaTransmision().subscribe(
			(response: MicromedidorUltimaTransmision[]) => {
				response.map(function (micrommedidor) {
					if (micrommedidor.tamper == null || micrommedidor.tamper == '') {
						micrommedidor.tamper = 'Sin datos'
					}

					if (micrommedidor.observacion == null || micrommedidor.observacion == '') {
						micrommedidor.observacion = 'Sin datos'
					}

					if (micrommedidor.contador == null || micrommedidor.contador == '') {
						micrommedidor.contador = 'Sin datos'
					}
				});

				response.forEach(
					micromedidor => {
						let numeroSerie = micromedidor.numeroSerie;
						if (!(temNumSeries.includes(numeroSerie))) {
							temNumSeries.push(numeroSerie);
							newResponse.push(micromedidor);
						}
					}
				);
				this.dataSource = newResponse;

				this.dataSource.forEach(micromedidor => {
					this.datosReporte.push({
						'Número de Serie': micromedidor.numeroSerie,
						'Última Transmisión': this.datePipe.transform(micromedidor.fechaHora, 'dd/MM/yyyy HH:mm a'),
						'Contador L': micromedidor.contador,
						'Observación': micromedidor.observacion
					});
				});
				if (this.datosReporte.length > 0) {
					this.isDisabled = false;
				}
			}
		)
	}

	informacionMicromedidor(data) {
		const dialogConfig = new MatDialogConfig();
		dialogConfig.autoFocus = true;
		dialogConfig.disableClose = true;
		dialogConfig.hasBackdrop = false;
		dialogConfig.width = "40%";
		dialogConfig.data = data;
		this.dialog.open(InformacionMicromedidorComponent, dialogConfig)
	}

	ubicarPuntoHistorico(data) {
		this.mapaService.verMedidor(data);
		this.dialogRef.close();
	}

	ubicarPuntoHistoricoDemo(data) {
		this.mapaService.verMedidorDemo(data);
		this.dialogRef.close();
	}

	public minimizarPopup() {
		this.dialogRef.addPanelClass('displayNone');
	}

	public maximizarPopup() {
		this.dialogRef.removePanelClass('displayNone');
	}

	public cerrarPopup() {
		this.dialogRef.close();
	}

}
